import { Component,OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AppComponent } from 'src/app/app.component'; 
import { Router } from '@angular/router';
import { SharkifyAiSerivceService } from 'src/app/sharkify-ai-serivce.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-manager-login',
  templateUrl:  './manager-login.component.html',
  styleUrls: ['./manager-login.component.css']
})
export class ManagerLoginComponent {

  c_p_hide: boolean = true;
  p_hide: boolean = true;
  ErrorLoggingIn: boolean = false;
  LoginErrorMessage: string = "";

  Email = new FormControl('', [
    Validators.required,
    Validators.email
  ]);

  Password = new FormControl('', [
    Validators.required, Validators.pattern(/^.{5}/)
  ]);
  constructor(
    public service: SharkifyAiSerivceService, 
    public router: Router,
    private toastr: ToastrService,
    public app: AppComponent
  ) { }

  ngOnInit(): void {
  }

  getEmailError() {
    if (this.Email.hasError('required')) {
      return 'Email is required.';
    }
    else if (this.Email.hasError('email')) {
      return 'Please enter a valid email address.';
    }
    else {
      return '';
    }

  }

  getPasswordError() {
    if (this.Password.hasError('required')) {
      return 'Password is required.';
    }
    else if (this.Password.hasError('pattern')) {
      return 'Please enter a password more than 5 letters';
    }
    else {
      return '';
    }

  }
  private showSuccess(message: string): void {
    this.toastr.success(message, 'Success', {
      toastClass: 'ngx-toastr toast-success'
    });
  }
  private showError(message: string): void {
    this.toastr.error(message, 'Error', {
      toastClass: 'ngx-toastr toast-error'
    });
  }
  ManagerName:string='';
  managerSignIn(){
    this.app.displayLoader(true);
    if (this.Email.valid && this.Password.valid) {
      this.service.AccountManagerLogin(this.Email.value + "", this.Password.value + "").subscribe(data => {
        this.app.displayLoader(false);
        if (data.Code === 200) {
          localStorage.setItem("authToken", "Accept" );
          localStorage.setItem("UserId", "" + data.UserDetails.UserId);
          this.ManagerName=data.UserDetails.FirstName + ' ' + data.UserDetails.LastName;
          localStorage.setItem("ManagerName", "" + this.ManagerName);
          // localStorage.setItem("BusinessInfo", "" + data.UserDetails[0].BusinessInfo);
          // this.BusinessInfo = localStorage.getItem("BusinessInfo");

          
          this.showSuccess('Manager Login Successful');
          this.router.navigate(["/ManagerDashboard"]);

        } else {
          this.showError('Manager Login Failed. Please check your credentials.');
        }
      }, error => {
        this.app.displayLoader(false);
        this.showError('Server error occurred. Please try again later.');
      });
    } else {
      this.app.displayLoader(false);
      this.showError('Please fill in valid credentials.');
    }

  }
  



}
